// Módulo escolhido pelo hostname. O GED é reconhecido pelo primeiro rótulo ("ged." ou "ged-sand."), porque o domínio
// docgedsistemas contém o texto "ged"; a Administração também ("adm." ou "adm-sand."), para não pegar a sigla no meio
// de outro nome. Os demais módulos seguem a regra de sempre (o hostname contém a sigla).
export type ModuleKey = 'sdp' | 'scp' | 'sge' | 'apm' | 'ser' | 'ouv' | 'sic' | 'ged' | 'adm' | '';

const GED_HOSTNAME = /^ged(-sand)?\./;
const ADM_HOSTNAME = /^adm(-sand)?\./;

// Mesma ordem de avaliação da cadeia original
const MODULES_BY_SUBSTRING: ModuleKey[] = ['sdp', 'scp', 'sge', 'apm', 'ser', 'ouv', 'sic'];

export function resolveModuleKey(hostname: string): ModuleKey {
    const url = hostname.toLowerCase();
    if (GED_HOSTNAME.test(url)) return 'ged';
    if (ADM_HOSTNAME.test(url)) return 'adm';
    return MODULES_BY_SUBSTRING.find((key) => url.includes(key)) ?? '';
}
